
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLoader } from "../../../../context/LoaderProvider.jsx";

// ✅ Styles
const containerStyle = {
  width: window.innerWidth > 768 ? "100%" : "93%",
  overflowX: "auto",
  scrollbarWidth: "thin",
  marginTop: "5px",
  WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  minWidth: "800px", // Ensure table has minimum width for horizontal scrolling
};

const thTdStyle = {
  border: "1px solid #ddd",
  textAlign: "center",
  padding: "12px 8px",
  fontSize: "14px",
};

const thStyle = {
  ...thTdStyle,
  backgroundColor: "#b15cd6",
  color: "#fff",
  fontWeight: "bold",
};

const WalletAdd = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("authToken");
  const vendorId = localStorage.getItem("vendorId");
  const { showLoader, hideLoader } = useLoader();

  // ✅ Fetch data from API
  const fetchRequests = () => {
    showLoader();
    axios
      .get(
        `https://backend.maamaas.com/subscription/api/vendorApproval/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => setRequests(res.data || []))
      .catch((err) => {
        console.error("Error fetching wallet approvals:", err);
        setRequests([]);
      })
      .finally(() => {
        hideLoader();
      });
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  // ✅ Approve request handler using PUT API
  const handleApprove = (index) => {
    const phoneNumber = requests[index].phoneNumber;

    const payload = [
      {
        phoneNumber: phoneNumber,
        vendorApproval: true,
      },
    ];

    setLoading(true);

    axios
      .put(
        `https://backend.maamaas.com/subscription/api/vendorApproval/update?vendorId=${vendorId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        const updatedRequests = [...requests];
        updatedRequests[index].vendorApproval = true;
        setRequests(updatedRequests);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error approving vendor:", err);
        setLoading(false);
      });
  };

  // Button style
  const buttonStyle = {
    backgroundColor: "#4CAF50",
    color: "#fff",
    border: "none",
    padding: "5px 10px",
    borderRadius: "5px",
    cursor: loading ? "not-allowed" : "pointer",
    opacity: loading ? 0.6 : 1,
    fontSize: "12px",
  };

  return (
    <div style={containerStyle}>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>S.No</th>
            <th style={thStyle}>User Name</th>
            <th style={thStyle}>Company</th>
            <th style={thStyle}>Restaurant</th>
            <th style={thStyle}>Phone Number</th>
            <th style={thStyle}>Post Paid</th>
            <th style={thStyle}>Approved</th>
            <th style={thStyle}>Credit Limit</th>
            <th style={thStyle}>Action</th>
          </tr>
        </thead>
        <tbody>
          {requests.length > 0 ? (
            requests.map((req, index) => (
              <tr key={index}>
                <td style={thTdStyle}>{index + 1}</td>
                <td style={thTdStyle}>{req.name}</td>
                <td style={thTdStyle}>{req.companyName}</td>
                <td style={thTdStyle}>{req.restaurentName}</td>
                <td style={thTdStyle}>{req.phoneNumber}</td>
                <td style={thTdStyle}>{req.postPaid ? "Yes" : "No"}</td>
                <td style={thTdStyle}>{req.vendorApproval ? "Yes" : "No"}</td>
                <td style={thTdStyle}>{req.creditLimit}</td>
                <td style={thTdStyle}>
                  {!req.vendorApproval ? (
                    <button
                      onClick={() => handleApprove(index)}
                      style={buttonStyle}
                      disabled={loading}
                    >
                      {loading ? "Approving..." : "Approve"}
                    </button>
                  ) : (
                    <span style={{ color: "green", fontWeight: "bold" }}>
                      Approved
                    </span>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" style={{ ...thTdStyle, textAlign: "center" }}>
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default WalletAdd;